import { User } from "../../../../auth/types";
import { httpWebApi } from "../../../../../core/http/httpThunks";
import { getParamsDateString } from "../../../../../core/util/functions";
import { DailySecurityReportFilter } from "../types";

export const getDailySecurityReport = (
  user: User,
  filter: DailySecurityReportFilter
) => {
  return httpWebApi<Blob>({
    method: "GET",
    responseType: "blob",
    timeout: 60 * 4 * 1000,
    url: "reporting/getsecdailytradingreport",
    params: {
      userid: user.userId,
      repdate: getParamsDateString(filter.reportDate),
    },
  });
};

export default getDailySecurityReport;
